<template>
  <div id="picked-up-list" v-if="pickupShipping.id">
    <div>
      <b-row>
        <b-col class="bg-white py-2">
          <span v-translate="{pickedupShippingsLength: shippings.length}">Total items: <strong>%{pickedupShippingsLength}</strong></span>
          <a href="#" @click.prevent="copyToClipboard(shippings.map(x => { return x.id }).join('\n'), '')" class="text-secondary" :title="$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
        </b-col>
        <b-col class="bg-white py-2 text-right" v-if="shippings.length > 0 && (pickupShipping.status === 'INTRANSIT' || pickupShipping.status === 'DELIVERED')">
          <b-button size="sm" variant="primary" @click.prevent="print()" style="padding: 0.1rem 1rem;">
            <font-awesome-icon icon="print" size="1x" style="font-size: 16px;vertical-align: middle" />
            <translate>Picked up shippings</translate>
          </b-button>
        </b-col>
      </b-row>
      <b-table striped
        :items="shippings"
        :fields="pickedupShippingsFields"
        :empty-text="$gettext('There are no picked up shippings to show yet')"
        show-empty
        v-if="prefetchDataLoaded"
      >
        <template v-slot:cell(id)="data">
          <a :href="'/shippings/' + data.value" target="_blank">{{data.value | uuid }}</a> <a href="#" @click.prevent="copyToClipboard(data.value)" class="text-secondary"  :title="$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
        </template>
        <template v-slot:cell(size_id)="row">
          {{shippingSizes.find(x => x.id === row.item.size_id) ? shippingSizes.find(x => x.id === row.item.size_id).name : ''}}
        </template>
        <template v-slot:cell(shipping_type_id)="row">
          {{shippingTypes.find(x => x.id === row.item.shipping_type_id) ? shippingTypes.find(x => x.id === row.item.shipping_type_id).name : ''}}
        </template>
      </b-table>

      <b-card class="full-article-card" id="manifest" v-if="printPickedUpList">
        <b-row>
          <b-col class="align-self-center">
            {{moment().format('L LT')}}
          </b-col>
          <b-col class="text-right">
            <img src="../assets/img/moova-blue.svg" alt="">
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <hr>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="align-self-center">
            <h4 class="mb-0" v-translate="{pickup: $options.filters.uuid(pickupShipping.id)}">Pickup: #%{pickup}</h4>
          </b-col>
          <b-col>
            <b-row v-if="pickupShipping.courier">
              <b-col cols="4" style="width: 50px !important;" class="align-self-center">
                <b-img thumbnail :src="(pickupShipping.courier.profile_picture || 'https://www.gravatar.com/avatar/default?s=100&r=pg&d=mm')" class="profile-image" alt="img" style="width: 100%; height: auto;" />
              </b-col>
              <b-col class="align-self-center">
                <h5>{{pickupShipping.courier.name}}</h5>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="align-self-center">
            <h5 class="mb-0 text-right" v-translate="{shippingsQty: shippings.length}">%{shippingsQty} shippings</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <hr>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="2">
            <strong v-translate>ID</strong>
          </b-col>
          <b-col cols="2" v-if="hasExternalCode">
            <strong v-translate>Code</strong>
          </b-col>
          <b-col cols="2" v-if="hasExternalOrderId">
            <strong v-translate>Order</strong>
          </b-col>
          <b-col cols="3">
            <strong v-translate>Destination Contact Name</strong>
          </b-col>
          <b-col>
            <strong v-translate>Destination Address</strong>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <hr>
          </b-col>
        </b-row>
        <b-row v-for="(shipping, index) in shippings" :key="index">
          <b-col cols="2">
            #{{shipping.id | uuid}}
          </b-col>
          <b-col cols="2" v-if="hasExternalCode">
            {{shipping.external_code}}
          </b-col>
          <b-col cols="2" v-if="hasExternalOrderId">
            {{shipping.external_order_id}}
          </b-col>
          <b-col cols="3">
            {{shipping.to_contact}}
          </b-col>
          <b-col>
            <span v-if="shipping.fields_revision_data &&
              shipping.fields_revision_data.to &&
              typeof shipping.fields_revision_data.to === 'object'" v-translate>
              Multiple possible addresses
            </span>
            <span v-else-if="shipping.fields_revision_data &&
              shipping.fields_revision_data.to &&
              typeof shipping.fields_revision_data.to === 'string'" v-translate>
              Address not recognized
            </span>
            <span v-else>{{shipping.address_to.formatted_address}}</span>
          </b-col>
          <b-col cols="12">
            <hr>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PickedUpList',
    props: {
      pickupShipping: {
        type: Object,
        default: () => {},
        required: true
      },
      shippings: {
        type: Array,
        default: () => [],
        required: true
      }
    },
    data () {
      return {
        printPickedUpList: false,
        prefetchDataLoaded: false,
        pickedupShippingsFields: [
          {
            key: 'id',
            label: this.$gettext('ID')
          },
          {
            key: 'status',
            label: this.$gettext('Status')
          },
          {
            key: 'size_id',
            label: this.$gettext('Size')
          },
          {
            key: 'shipping_type_id',
            label: this.$gettext('Type')
          }
        ]
      }
    },
    computed: {
      hasExternalCode() {
        return this.shippings.findIndex(x => x.external_code) !== -1
      },
      hasExternalOrderId() {
        return this.shippings.findIndex(x => x.external_order_id !== null) !== -1
      }
    },
    created() {
      this.fetchShippingSizes()
        .then(() => {
          this.fetchShippingTypes()
            .then(() => {
              this.prefetchDataLoaded = true
            })
        })
    },
    methods: {
      print() {
        this.printPickedUpList = true
        this.$nextTick(() => {
          this.$htmlToPaper('manifest', null, () => {
            this.printPickedUpList = false
          })
        })
      }
    }
  }
</script>

<style lang="scss">
.full-article-card {
  padding: 40px 60px;
  background-color: white;
  .card-body {
    padding: 0;
  }
}
.author-text.full-article-author-meta {
  background-color: rgba(0,0,0,0.02);
  padding: 1em 4em;
  margin: 30px -60px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  font-size: 13px
}
.full-article-author-image {
  border-radius: 4px;
  max-height: 40px;
  display: inline-block;
}
.x {
  display: none;
}
</style>
